import { injectable, injectFromBase } from 'inversify'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import UndoRedoHistory from '@/data/models/UndoRedoHistory'

@injectable()
@injectFromBase()
@RepoSettings<Endpoint>({
  model: UndoRedoHistory,
})
export default class UndoRedoHistoryRepository<State = unknown> extends OrmApiRepository<UndoRedoHistory<State>> {
  public clear(key: string) {
    this.delete([key])
  }
}
